import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getListTermStore = (state: AppState) => state.termDepositList;
const getListTermDeposit = (state: AppState) => state.termDepositList.listTermDeposit;
const getPending = (state: AppState) => state.termDepositList.pending;

export const getListTermStoreSelector = createSelector(getListTermStore, (data) => data);
export const getListTermDepositSelector = createSelector(getListTermDeposit, (data) => data);
export const getListTermDepositPendingSelector = createSelector(getPending, (status) => status);
